import { Box, Chip, IconButton, Tab, Tabs, Typography } from "@mui/material";
import MaterialTable from "material-table";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { GetApproverMprRequestsAction } from "../../../../../store/ATS/MprRequest/Action";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Popup from "../../../Base/views/Popup";
import AddMPRPopup from "./AddMPRPopup";
import { MprStatusRenderer, getStatusColor } from "./MprStatusRenderer";
import { ConvertDateTime, getAtsUserId } from "../../../Base/helper/baseFunctions";
import {LabelWithInfo} from "../../../Base/views/LabelwithInfo";

const ApprovalsTab = () => {
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const { approver_mpr_requests, isLoadingApproverMprRequests } = useSelector(
    (state) => state?.AtsReducer?.MprRequestReducer
  );
  const [openPopup, setOpenPopup] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);
  const [openActionPopup, setOpenActionPopup] = useState(false);
  const [approverMprRequests, setApproverMprRequests] = useState([]);
  const [initialActionType, setInitialActionType] = useState("");
  const [isApproveFlow, setIsApproveFlow] = useState(false);

  const handleAction = (rowData, type) => {
    setEditedRecord(rowData);
    setInitialActionType(type);
    setOpenActionPopup(true);
  };
  const closeMode = (resetForm) => {
    setEditedRecord(null);
    setInitialActionType("");
    setIsApproveFlow(false);
    setOpenPopup(false);
    setOpenActionPopup(false);
  };
  const handleApproveClick = async (rowData) => {
    setIsApproveFlow(true);
    setInitialActionType("Approved");
    await handleEdit(rowData);
  };
  const handleEdit = async (rowData) => {
    setLoading(true);
    try {
        const { fnGetMprRequestsHelper } = await import("../../helper/AtsMprRequestHelper");
        const res = await fnGetMprRequestsHelper();
        if (res && !res.hasError && res.data && res.data.data) {
            const fullMpr = res.data.data.find(r => String(r.mpr_requests_pk) === String(rowData.mpr_requests_pk));
            setEditedRecord(fullMpr ? { ...rowData, ...fullMpr } : rowData);
        } else {
            setEditedRecord(rowData);
        }
    } catch (e) {
        setEditedRecord(rowData);
    }
    setLoading(false);
    setOpenActionPopup(true);
  };
  const handleChange = (event, newValue) => {
    setLoading(true);
    setValue(newValue);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    if (approver_mpr_requests) {
      if (value === 0) { // loggedIn user is first approver or status is Awaiting and user is second/third approver
        const filterIasFirstApprover = (approver_mpr_requests || [])?.filter((el) => (+el?.approver_id === getAtsUserId() && el?.mpr_status === "Submitted") ||
          (+el?.second_approver_employee_id === getAtsUserId() && el?.mpr_status === "Awaiting Second Approval") ||
          (+el?.third_approver_employee_id === getAtsUserId() && el?.mpr_status === "Awaiting Third Approval"))
        setApproverMprRequests(filterIasFirstApprover)
      } else {
        setApproverMprRequests(approver_mpr_requests)
      }
    }
    // eslint-disable-next-line
  },[approver_mpr_requests])


  useEffect(() => {
    dispatch(GetApproverMprRequestsAction({all_status: value === 0 ? false : true}));
  }, [dispatch, value]);



  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
            minHeight: "40px", mb: 1, ".MuiTab-root": { minHeight: "20px" },
            '& .MuiTabs-indicator': {
                width: '100%',
                display: 'flex',
                justifyContent: "center !important",
            },
        }} 
      >
        <Tab label={`Action Required`} {...a11yProps(0)} />
        <Tab label={`All`} {...a11yProps(1)} />
      </Tabs>
      <Box
        sx={{
          maxHeight: "calc(100vh - 155px)",
          overflowY: "auto",
        }}
      >
        <MaterialTable
          onRowClick={value === 0 ? undefined : (event, rowData) => handleEdit(rowData)}
          columns={[
            { title: "MPR ID", field: "mpr_no" },
            { title: "Designation", field: "role" },
            { title: "Department", field: "bu_name" },
            { title: "Location", field: "location", render: (rowData) => rowData?.location || "-" },
            ...(value === 0 ? [
                { title: "Requested Headcount", field: "headcount", align: "center" },
                {
                    title: "Requested Budget",
                    field: "max_budget",
                    align: "right",
                    render: (rowData) => {
                        if (rowData?.is_budgeted === false) return "Non Budgeted";
                        return rowData?.max_budget ? rowData.max_budget : "N/A";
                    }
                }
            ] : [
                { title: "Approved Headcount", field: "approved_headcount", align: "center", render: rowData => rowData?.approved_headcount || "N/A" },
                {
                    title: "Approved Budget",
                    field: "approved_budget",
                    align: "right",
                    render: (rowData) => {
                        if (rowData?.is_budgeted === false) return "Non Budgeted";
                        const val = rowData?.approver_budget ?? rowData?.approved_budget;
                        return val !== null && val !== undefined && val !== "" ? val : "N/A";
                    }
                }
            ]),
            { title: "Requested By", field: "mpr_owner_name",
              render: rowData => rowData?.mpr_owner_name && rowData?.createdon ? (  
                    <LabelWithInfo variant="body1" props={{infoSize: 18}} 
                        label={rowData?.mpr_owner_name} tooltip={`Requested On: ${ConvertDateTime(rowData?.createdon)}`} />
                    ) : rowData?.mpr_owner_name ? rowData?.mpr_owner_name : "-"
             },
            {
              title: "Status",
              headerStyle: {
                textAlign: "center",
              },
              cellStyle: {
                textAlign: "center",
              },
              field: "mpr_status",
              render: (rowData) => <MprStatusRenderer rowData={rowData} />,
            },
          ]}
          data={approverMprRequests || []}
          isLoading={isLoadingApproverMprRequests || loading}
          options={{
            maxBodyHeight: "calc(100vh - 280px)",
            minBodyHeight: "calc(100vh - 280px)",
            rowStyle: {
              fontSize: "13px",
              height: "35px",
            },
            cellStyle: {
              padding: "5px 0px 5px 13px",
            },
            headerStyle: {
              padding: "5px 10px 5px 10px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            grouping: false,
            columnsButton: false,
          }}
          actions={
            value === 0
              ? [
                {
                  icon: () => (
                    <IconButton sx={{ padding: "0px" }}>
                      <CheckCircleIcon color="primary" />
                    </IconButton>
                  ),
                  tooltip: "Approve",
                  onClick: (_event, rowData) => {
                    handleApproveClick(rowData);
                  },
                },
                {
                  icon: () => (
                    <IconButton sx={{ padding: "0px", color: "#d32f2f" }}>
                      <CancelIcon />
                    </IconButton>
                  ),
                  tooltip: "Reject",
                  onClick: (_event, rowData) => {
                    handleAction(rowData, "Rejected");
                  },
                },
              ]
              : []
          }
          title={getExpenseTableTitle(value)}
        />

        <Popup
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <span>
                {initialActionType
                  ? (initialActionType === 'Approved' ? `Approve MPR${editedRecord?.mpr_no ? ` - ${editedRecord.mpr_no}` : ''}` : `Reject MPR${editedRecord?.mpr_no ? ` - ${editedRecord.mpr_no}` : ''}`)
                  : `Preview MPR${editedRecord?.mpr_no ? ` - ${editedRecord.mpr_no}` : ''}`}
              </span>
              {editedRecord?.mpr_status && (
                <Chip
                  label={editedRecord.mpr_status}
                  size="small"
                  style={{
                    backgroundColor: getStatusColor(editedRecord.mpr_status).bg,
                    color: getStatusColor(editedRecord.mpr_status).text,
                    fontWeight: 600,
                    fontSize: "12px",
                    height: "22px",
                  }}
                />
              )}
            </Box>
          }
          openPopup={openActionPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="md"
        >
          <AddMPRPopup
            setOpenPopup={setOpenActionPopup}
            editedRecord={editedRecord}
            closeMode={closeMode}
            isApproveFlow={isApproveFlow}
            initialActionType={initialActionType}
          />
        </Popup>
      </Box>
    </Box>
  );
};


  const getExpenseTableTitle = (value) => {
    if (value === 0) {
      return (
        <Box>
          <Typography variant="h6" fontWeight={600}>
            MPR Requiring Action
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review and approve/reject pending MPRs
          </Typography>
        </Box>
      );
    } else if (value === 1) {
      return (
        <Box>
          <Typography variant="h6" fontWeight={600}>
            All MPRs
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View all MPRs and their status
          </Typography>
        </Box>
      );
    } else {
      return (
        <Typography variant="h6" fontWeight={600}>
          MPRs
        </Typography>
      );
    }
  };
export default ApprovalsTab;